// extracted by mini-css-extract-plugin
export var blue = "_3l-g";
export var brand = "_3l-c";
export var darkGrey = "_3l-f";
export var disabled = "_3l-6";
export var disabledSubtle = "_3l-7";
export var error = "_3l-8";
export var green = "_3l-h";
export var grey = "_3l-e";
export var icon = "_3l-0";
export var inherit = "_3l-b";
export var lightGrey = "_3l-d";
export var orange = "_3l-j";
export var pink = "_3l-l";
export var primary = "_3l-1";
export var purple = "_3l-m";
export var quaternary = "_3l-4";
export var quinary = "_3l-5";
export var red = "_3l-k";
export var secondary = "_3l-2";
export var success = "_3l-a";
export var tertiary = "_3l-3";
export var warning = "_3l-9";
export var white = "_3l-n";
export var yellow = "_3l-i";